import { checkIsMobile } from "@/utils/utils"

export const responsiveMixin = {
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.checkScreenType()
    window.addEventListener("resize", this.checkScreenType)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenType)
  },
  methods: {
    checkScreenType() {
      this.isMobile = checkIsMobile()
    },
  },
}
